import { settings, optionAxios } from "@/eyecon.js";
import { ThemeManager } from "@/utils/themeManager.js";
import Vue from "vue";
const state = {
  cloudLogin: null,
  slogans: [
    {
      title: "Engage, Inform, Inspire",
      description:
        "Capture attention, share your message, and inspire action with EYECON’s innovative signage solutions.",
    },
    {
      title: "Control Your Message, Anywhere, Anytime",
      description:
        "Take charge of your content with EYECON’s flexible platform, delivering seamless control across all displays.",
    },
    {
      title: "Vibrant Visuals, Seamless Updates",
      description:
        "Brighten your screens with EYECON’s vivid visuals and effortless real-time content updates.",
    },
    {
      title: "Scale Smart, Shine Bright",
      description:
        "Expand your reach with EYECON’s scalable signage, designed to make your brand shine brilliantly.",
    },
    {
      title: "Your Brand, Amplified",
      description:
        "Boost your brand’s presence with EYECON’s advanced displays for dynamic, impactful messaging.",
    },
    {
      title: "Real-Time, Real Impact",
      description:
        "Drive instant engagement with EYECON’s real-time signage solutions for maximum impact.",
    },
    {
      title: "Transform Your Screens",
      description:
        "Revolutionize displays with EYECON’s cloud-based system for seamless, dynamic content delivery.",
    },
    {
      title: "Interactive, Engaging",
      description:
        "Redefine engagement with EYECON’s interactive signage, crafted to captivate and connect.",
    },
    {
      title: "From Vision to Victory",
      description:
        "Bring your ideas to life with EYECON’s dynamic content, turning vision into success.",
    },
    {
      title: "Captivate Your Audience",
      description:
        "Hold attention with EYECON’s vibrant displays, tailored to engage and inspire your audience.",
    },
    {
      title: "Effortless Control, Endless Possibilities",
      description:
        "Simplify management with EYECON’s intuitive tools, unlocking endless creative opportunities.",
    },
    {
      title: "Bright Ideas, Brighter Screens",
      description:
        "Transform ideas into reality with EYECON’s innovative screens, leading the signage industry.",
    },
    {
      title: "Connect, Create, Celebrate",
      description:
        "Build connections and create impactful content with EYECON’s revolutionary signage solutions.",
    },
    {
      title: "Your Story, Our Screens",
      description:
        "Tell your brand’s story with EYECON’s vivid screens, designed for dynamic storytelling.",
    },
    {
      title: "Seamless, Stunning, Smart",
      description:
        "Achieve flawless, smart signage with EYECON’s stunning and seamless digital solutions.",
    },
    {
      title: "Power Your Brand’s Voice",
      description:
        "Amplify your message with EYECON’s cloud-powered tools for real-time, impactful content.",
    },
    {
      title: "Illuminate Your Message",
      description:
        "Highlight your message with EYECON’s superior visual technology for unmatched clarity.",
    },
    {
      title: "Engage Today, Excel Tomorrow",
      description:
        "Connect with audiences now and build future success with EYECON’s intelligent signage.",
    },
    {
      title: "Bold Displays, Brilliant Results",
      description:
        "Rely on EYECON’s bold, high-performance displays for brilliant, measurable results.",
    },
  ],
  usingSSL: false,
  domainName: "",
  enable2fa: false,
  app: {
    whiteLabel: -1,
    logoPath: "eyecon-invert.svg",
    productName: "EYECON R3",
    appTitle: "Digital Signage System",
    color: { name: "deep-purple-7", hex: "#5e35b1" },
  },
};
const getters = {
  cloudLogin: (state) => state.cloudLogin,
  slogans: (state) => state.slogans,
  usingSSL: (state) => state.usingSSL,
  domainName: (state) => state.domainName,
  enable2fa: (state) => state.enable2fa,
  app: (state) => state.app,
};
const actions = {
  async __getServerSettings({ commit }) {
    var ret = false;
    try {
      var response = await Vue.axios.get(
        settings.serverUrl + "/CloudLogin/server-settings",
        optionAxios
      );
      if (response && response.status === 200) {
        ret = true;
        commit("__getServerSettings", response.data);
      }
    } catch (err) {
      //console.error(err);
      ret = false;
    }
    return ret;
  },
  // eslint-disable-next-line no-unused-vars
  async __checkAccountExist({ commit }, payload) {
    let ret = null;

    try {
      optionAxios.headers["Account-Id"] = payload.domain;
      var response = await Vue.axios.post(
        settings.serverUrl + "/CloudLogin/check-account-exist-v2",
        payload,
        optionAxios
      );
      if (response && response.status === 200) {
        ret = response.data;
        commit("__enable2fa", ret.enable2fa);
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        ret = err.response.data;
      } else {
        ret = null;
      }
    }
    return ret;
  },

  async __login({ commit }, payload) {
    var ret = false;
    try {
      optionAxios.headers["Account-Id"] = payload.domain;
      var response = await Vue.axios.post(
        settings.serverUrl + "/CloudLogin/login-v2",
        payload,
        optionAxios
      );
      if (response && response.status === 200) {
        commit("__loginSuccess", response.data);
        if (response.data) ret = true;
      } else {
        ret = false;
      }
    } catch (err) {
      //console.error(err);
      ret = false;
    }
    return ret;
  },

  // eslint-disable-next-line no-unused-vars
  async __loginWithGoogleAccount({ commit }, payload) {
    let ret = null;
    try {
      optionAxios.headers["Account-Id"] = payload.domain;
      let response = await Vue.axios.post(
        settings.serverUrl + "/CloudLogin/login-with-google-account",
        payload,
        optionAxios
      );
      if (response && response.status === 200) {
        commit("__loginSuccess", response.data);
        commit("__enable2fa", response.data.twoFactorSecret != null);
        ret = response.data;
      } else {
        ret = null;
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        ret = err.response.data;
      } else {
        ret = null;
      }
    }
    return ret;
  },
  // eslint-disable-next-line no-unused-vars
  async __linkAccount({ commit }, payload) {
    let ret = null;

    try {
      let response = await Vue.axios.post(
        settings.serverUrl + "/CloudLogin/link-google-account",
        payload,
        optionAxios
      );
      if (response && response.status === 200) {
        commit("__loginSuccess", response.data);
        ret = response.data;
      } else {
        ret = null;
      }
    } catch (err) {
      ret = null;
    }
    return ret;
  },
  // eslint-disable-next-line no-unused-vars
  async __forgotPassword({ commit }, payload) {
    var ret = 0;
    try {
      optionAxios.headers["Account-Id"] = payload.domain;
      var response = await Vue.axios.post(
        settings.serverUrl + "/forgotPassword",
        payload,
        optionAxios
      );
      if (response && response.status === 200) {
        ret = 1;
      }
    } catch (err) {
      ret = 2;
    }
    return ret;
  },
  // eslint-disable-next-line no-unused-vars
  async __verifyTOTP({ commit }, payload) {
    try {
      var response = await Vue.axios.post(
        settings.serverUrl + "/login/verify-totp",
        payload,
        optionAxios
      );
      if (response && response.status === 200) {
        return true;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  },
};
const mutations = {
  __getServerSettings: (state, ret) => {
    state.domainName = ret.domainName;
    state.usingSSL = ret.usingSSL;
    var w = ret.whiteLabel;
    if (w.enabled) {
      state.app.whiteLabel = 1;
      state.app.logoPath = w.logoFile.id + "." + w.logoFile.extension;
      state.app.productName = w.appName;
      state.app.appTitle = w.appTitle;
      state.app.color = JSON.parse(w.appColor);
      document.title = `Sign In - ${w.appName}`;
    } else {
      state.app.whiteLabel = 0;
    }
    ThemeManager.updateTheme(state.app.color.hex);
  },
  __enable2fa: (state, enable) => {
    state.enable2fa = enable;
  },
  __loginSuccess: (state, ret) => {
    state.cloudLogin = ret;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
